import { useEffect, useState } from "react"
import ConditionalRender from "../../../ConditionalRender"
import { setState } from "../../utils/CommonReducer"
import { AnInputBox } from "../../input_utils/AnInput"
import Icon from "../../utils/Icon"
import { create_or_update_report } from "./api"

const AiConversation = ({
    filterState, 
    setFilterState, 
    isLoading,
    fetchList,
    report_id, 
    // applied_filters, 
    // is_parent_list, 
    ...props
}) => {
    const {messages} = filterState
    const [prompt, setPrompt] = useState('');
    const submitPrompt = () => {
        if(!prompt) return
        setState(setFilterState)({messages: [...filterState.messages, {content: prompt, type: 'User'}, {content: "...thinking", type: 'ai_bot'}]})
        setPrompt("")
        create_or_update_report({smart_filter_term: prompt, id: report_id}).then((response) => {
            fetchList()
        }).catch((error) => {
        })
    }
    const handleOnKeyDown = (e) => {
        if (e.key === "Enter") {
            submitPrompt()
        }
    };
    return (
        <div style={{width: "100%"}}>
        <div className="filter_padding">
            <div className='text_title_big' style={{paddingBottom: 12}}>Create Report</div>
            <div style={{overflow: 'auto', height: 400, display: 'flex',flexDirection: 'column' }}>
            {messages.map((message, index) => {
                return (
                    <div className="text_hint" key={index}>
                        <ConditionalRender if={message.type === 'User'}>
                            <div className="default_flex_container" style={{float: 'right', alignItems: 'flex-start', marginTop: 24}}>
                                <div style={{padding: '6px 8px 0px 0px', cursor: 'pointer'}} onClick={() => navigator.clipboard.writeText(message.content)} ><Icon name="Copy"/></div>
                                <div className="user-input-box-container">
                                    <div className="user-input-box">{message.content}</div>
                                </div>
                            </div>
                        </ConditionalRender>
                        <ConditionalRender if={message.type === 'ai_bot'}>
                        <div style={{paddingTop: 24, clear: 'right'}}>
                            <div>{message.content}</div>
                        </div>
                        </ConditionalRender>
                    </div>
                )
            })}
            </div>
        </div>
        <div className="filter_padding" style={{position: 'fixed', height: '100px', bottom: 0, left: 0, maxWidth: 380, width: '100%', margin: '0px 6px 36px'}}>
            <div style={{position: 'relative'}}>
                <AnInputBox
                    style={{
                        margin: 'auto',
                    }}
                >
                    <textarea
                        type="text"
                        id="prompt"
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}
                        onKeyDown={handleOnKeyDown}
                        placeholder="Describe what you want to generate"
                        style={{ borderRadius: 8, boxShadow: '2px 2px 6px 0px rgba(0, 0, 0, 0.25), -1px -1px 6px 0px rgba(0, 0, 0, 0.25)', background: '#FAFBFC', border: 'none' }}
                    />
                    <div style={{position: 'absolute', right: 8, bottom: 12}}><Icon name="GreenArrowCircleRight" onClick={() => submitPrompt()}/></div>
                </AnInputBox>
            </div>
        </div>
    </div>
    )
}
export default AiConversation